function configure(Highcharts) {
    Highcharts.setOptions({
        lang: {
            thousandsSep: " ",
            decimalPoint: ",",
            months: ["január", "február", "március", "április", "május", "június", "július", "augusztus", "szeptember", "október", "november", "december"],
            shortMonths: ["jan", "febr", "márc", "ápr", "máj", "jún", "júl", "aug", "szept", "okt", "nov", "dec"],
            weekdays: ["vasárnap", "hétfő", "kedd", "szerda", "csütörtök", "péntek", "szombat"],
            numericSymbols: ["k", "M", "G", "T", "P", "E"],
            loading: "Betöltés...",
            contextButtonTitle: "Grafikon menü",
            printChart: "Grafikon nyomtatása",
            downloadJPEG: "JPEG letöltése (kép)",
            downloadPNG: "PNG letöltése (kép)",
            downloadSVG: "SVG letöltése (kép)",
            downloadPDF: "PDF letöltése (kép)",
            downloadCSV: "CSV letöltése (adat)",
            downloadXLS: "XLS letöltése (adat)",
            viewFullscreen: "Megtekintés teljes képernyőben",
            exitFullscreen: "Kilépés teljes képernyős módból",
            zoomIn: "Nagyít",
            zoomOut: "Kicsinyít",
            resetZoom: "Eredeti nagyítás",
            resetZoomTitle: "Alapértékre állítja a nagyítás mértékét",
            rangeSelectorFrom: "Tól",
            rangeSelectorTo: "Ig",
            rangeSelectorZoom: "Nagyítás",
            drillUpText: "\u25c1 Vissza: {series.name}",
        }
    });
}
export default configure;
